import { i18next } from '@frontend/i18n';

export const APPOINTMENT_SCHEDULED_CHART_APPEARANCE = {
  borderRadius: 8,
  height: 190,
  innerRadius: 70,
  minWidth: 180,
  outerRadius: 94,
};

export const FOLLOW_UP_TASKS_CHART_APPEARANCE = {
  barSize: 60,
  groupsGap: 60,
  showYAxis: true,
  showXAxis: true,
  skipBarRadiusOnStackJoins: true,
  mode: 'stacked' as const,
  barBorderWidth: 1,
  alwaysApplyBarBorders: true,
  margin: { left: -16 },
};

export const SCHEDULING_OPPORTUNITIES_CHART_APPEARANCE = {
  barSize: 40,
  groupsGap: 24,
  layout: 'vertical' as const,
  showYAxis: false,
  margin: { top: 0, right: 8, left: 16, bottom: 0 },
  hideTooltip: false,
  barBorderWidth: 1,
  alwaysApplyBarBorders: true,
};

export const LabelMap: Record<string, string> = {
  Scheduled: i18next.t('Scheduled', { ns: 'analytics' }),
  Rescheduled: i18next.t('Rescheduled', { ns: 'analytics' }),
  Staff_Answered: i18next.t('Staff Answered', { ns: 'analytics' }),
  Staff_Unanswered: i18next.t('Staff Unanswered', { ns: 'analytics' }),
  Unscheduled: i18next.t('Unscheduled', { ns: 'analytics' }),
  Recovered_Opportunity: i18next.t('Recovered Opportunity', { ns: 'analytics' }),
  Scheduling: i18next.t('Scheduling', { ns: 'analytics' }),
  Other: i18next.t('Other', { ns: 'analytics' }),
  Total_Ai_Conversations: i18next.t('Total AI Conversations', { ns: 'analytics' }),
  Staff_Transfer_Messages: i18next.t('AI-Initiated Staff Transfer Messages', { ns: 'analytics' }),
};

export enum LABEL_KEYS {
  VOICE = 'Voice',
  MESSAGE = 'Message',
}

export const AIR_FEATURE_FLAGS = {
  DEMO_MODE: 'analytics-air-demo-mode',
};
